<template id="simple-report-page">
  <section>
    <div class="m-1">
      <div class="">
        <div class="card" :class="this.$store.state.bannerStatus ? 'banner-true' : 'banner-false'">
          <div class="card-header text-left">
            <i class="fa fa-file"></i> {{ repTitle }}
            <div class="float-right">
                   <span v-for="(ai,index) in currentRepActionIconsData" :key="index">
          <download-csv v-if="ai.actionIconsName=== 'download'" class="btn btn-default" :data="cleanedDownload"
                        :name="momentAll" v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
            <i v-bind:id="ai.iconId" v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
               :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
               style="font-size:15px; float: right; margin-top: -3px; ">
            </i>
          </download-csv>

          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
              <i v-if="ai.actionIconsName!== 'download'" v-bind:id="ai.iconId"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:15px; padding-left:10px;">
              </i>
          </span>
        </span>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive" >
              <div>
                <table width="100%">
                  <tr>
                    <th class="thead-dark" align="center" v-for="key in dimSelectDpValues" v-bind:key="key"> {{ key }}
                    </th>
                    <b>Generic Search</b>
                  </tr>
                  <tr>
                    <td v-for="(key,index) in dimSelectDpValues" v-bind:key="key">
                      <v-select multiple style="padding: 5px;" v-bind:key="key"
                                v-model="selectVal[rowsDataDimKeys[index]]" :options="options[rowsDataDimKeys[index]]">

                        <!--<option value="">All</option>
                        <option style="width: 30px;" :value="option" v-for="option in options[rowsDataDimKeys[index]]" :key="option">{{ option }}</option>-->
                      </v-select>
                    </td>
                    <input type="text" v-model="filterValue" placeholder="Search">
                  </tr>
                </table>
              </div>
              <div class="overflow-auto" >
                <div style="text-align:right; display:inline-block;">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      align="center"
                      aria-controls="my-table"
                  ></b-pagination>
                </div>
                <div style="text-align: left;display:inline-block; padding: 10px; ">
                  <p class="sm-2 text-primary">No.of Rows: {{ rows }}</p>
                </div>

                <!--                <span style="padding-top:1em;">No.of Rows: {{rows}}</span>-->
                <!--        <p class="mt-3">Current Page: {{ currentPage }}</p>-->
                <div class="scrollmenuRepo" :style="{ height:$store.state.bannerStatus ? '65vh' : '72vh'}" style="position: relative;">
                  <b-table
                      id="my-table"
                      :items="filteredItems"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :fields="merged_column_label"
                      :sort-by.sync="sortBy1"
                      :sort-desc.sync="sortDesc"
                      sort-icon-right
                      bordered
                      small>

                    <!--                  <b-table-column numeric v-for="header in numeric_headers" v-slot=></b-table-column>-->
                    <!--                  <template #cell()="filteredItems">-->
                    <!--        <span :class="{ right: typeof filteredItems.value == 'number', left: typeof filteredItems.value != 'number' }">-->
                    <!--          {{ filteredItems.value }} </span>-->
                    <!--                  </template>-->
                    <template v-for="header in numeric_headers"  v-slot:[toCellName(header)]="filteredItems" >
                      <div class="text-right" v-bind:key="header">{{ filteredItems.value }}</div>
                    </template>
                    <!--                  <template v-slot:cell(rm2)="filteredItems">-->
                    <!--                    <div class="text-right">{{ filteredItems.value }}</div>-->
                    <!--                  </template>-->
                    <!--                  <template v-slot:cell(rm3)="filteredItems">-->
                    <!--                    <div class="text-right">{{ filteredItems.value }}</div>-->
                    <!--                  </template>-->
                  </b-table>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import moment from "moment";

//var $ = require("jquery");

export default {
  name: 'simple-report-page',

  data: function () {
    return {
      output: [],
      repTitle: '',
      columns: [],
      keys: [],
      rowsdata: [],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      currentRepActionIconsData: {},
      cleanedDownload:[],
      iconOnChangeFlag: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },
      perPage: 20,
      currentPage: 1,
      merged_column_label: [],
      sortBy1: '',
      sortDesc: false,
      numeric_headers: ['rm1','rm2','rm3','rm4','rm5','rm6','rm7','rm8','rm9','rm10'],
    }
  },
  created: function () {
    //this.loadCustomerSales()
    //   this.loadReportConfig()
    this.listenToRouter()
  },
  mounted: function () {
    // this.init();
    this.loadReportConfig()

  },
  computed: {
    rows() {
      return this.filteredItems.length
    },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      return Object.keys(this.rowsdata[0])
    },
    "orderedData": function () {
      let result = this.apiData;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;
        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {
          if (this.selectVal[key]) {
            // console.log("filter ", this.selectVal,this.selectVal[key].length==0)
            keep =
                keep &&
                (this.selectVal[key].length == 0 ||
                    //item[key] === this.selectVal[key]); // true && (false ||
                    this.selectVal[key].includes(item[key])); // true && (false ||
          }
        });
        return keep;
      });
      if (this.filterValue) {
        /* Filters the report Data based on the entered value in the generic search box
           loop over the keys of the inner object and use Array.some()
           It will work for any number of keys of any name so no need to get depend on the keys
           to get the match of the searched text use includes()
           to make the search non case sensitive use toLowerCase()
           to avoid NULL values in filtering excluded null values by taking !=Null and with && operator
           Numeric values gave obj[key].includes is not function error so converted them to string using toString()
        */
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))
        );
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    options() {
      const options = {};

      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);

        console.log("Options Data Vals", vals);

        // Create a unique set of values
        const uniqueVals = Array.from(new Set(vals));

        // Check if the values are date-related and sort accordingly
        if (uniqueVals.every(value => this.isDateRelated(value))) {
          // Sort date-related values in descending order
          options[key] = uniqueVals.sort((a, b) =>{
            const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

            // Special case: Month names (case insensitive)
            if (monthPattern.test(a) && monthPattern.test(b)) {
              const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const aNormalized = a.slice(0, 3).toLowerCase(); // Normalize to lowercase
              const bNormalized = b.slice(0, 3).toLowerCase();
              return monthOrder.indexOf(bNormalized) - monthOrder.indexOf(aNormalized);
            }
            return this.parseDate(b) - this.parseDate(a)
          });
        } else {
          // Sort non-date-related values in ascending order
          options[key] = uniqueVals.sort();
        }

        console.log("Sorted Options Data for Key", key, options[key]);
      });

      return options;
    }
  },
  methods: {
    toCellName (slot) {
      console.log("slot:",slot)
      return `cell(${slot})`
    },
    sortBy: function (key) {
      console.log("The sort Key is ", key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey = key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    },

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };


      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }

      return 0; // Default for non-date-related values
    },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns = []
        $this.merged_column_label = []
        setTimeout(() => {
          $this.loadReportConfig()
        }, 300)

      })
    },
    handleActionIconFunctionCall(fnName, index,x) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      console.log("Handle function called with func name", fnName, this.iconOnChangeFlag,x)
      this[fnName](x)
    },

    commentBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
          this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
          },
          (e) => {
            this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },

    loadReportConfig:async function () {
      console.info('loading summary')
      let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      //Get Request
      axios.get('/api/reportConfigColumn/' + menuParam)
          //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
          .then(res => {
            this.apiData = res.data
            this.rowsdata = this.apiData.rowsData
            this.repTitle = this.apiData.columns[0].reportName
            //this.columns = this.apiData.columns
            this.columns = this.apiData.columns.map(function (el) {
              return el.headerColumnDisplay;
            })
            this.icons = this.apiData.icons
            this.cleanedDownload = this.apiData.downloadRowsData
            this.momentAll = `${moment().format('YYYY-MM-DD hh:mm')}_${this.repTitle}.csv`
            console.log('ReportConfigRes', this.apiData)
            var rowsDataKeys = Object.keys(this.rowsdata[0])
            this.rowsDataDimKeys = rowsDataKeys.filter(dim => dim.includes('d'))
            this.dimSelectDpValues = this.columns.slice(0, this.rowsDataDimKeys.length)
            console.log('Dimension variables Keys', this.rowsDataDimKeys)
            console.log('Data for Report', this.rowsdata)
            console.log('Dimension variables Keys', this.dimSelectDpValues)
            //console.log('Report Title',this.apiData.columns[0].repName)
            //console.log('Report headers',this.nameArray)

            //Rep level action icons
            let actionIconsData = this.$store.state.actionIcons
            let repIcons = this.icons.filter(indi => indi.drilldownLevel == 'level1') // get only level1 for report level icons
            console.log('Rep Icons:', repIcons)
            var repActionIconsSyspkArray = repIcons[0].repActionIconsSyspkArray ? repIcons[0].repActionIconsSyspkArray : []
            console.log('Rep Action icons', repActionIconsSyspkArray, repIcons[0].repActionIconsSyspkArray)
            this.currentRepActionIconsData = actionIconsData.filter(r => repActionIconsSyspkArray.includes(r.syspk))
            console.log('Rep Action icons:',repActionIconsSyspkArray)

            //b-table header
            for (let i = 0; i < this.Rcolumns.length; i++) {
              this.merged_column_label.push({
                key: this.Rcolumns[i],
                label: this.columns[i],
                sortable: true,
                tdClass: 'text-left',
                thClass: 'text-center bg-info text-light',
              })
            }
            console.log("columns:", this.merged_column_label);



            /*   $('td').filter(function () {
                 return /^[.,\d]+$/.test($(this).text());
               })
                   .css({
                     'text-align': 'right'
                   });

               $('td').filter(function () {
                 return /^[a-zA-Z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test($(this).text());
               })
                   .css({
                     'text-align': 'left'
                   });
   */

          }, err => {
            console.log('Error Fetching data', err)
          })


      /*               //Get Request
                      axios.get('/api/reportConfigColumn/'+ menuParam +'/G01')
                      .then(res => {
                      this.drilldowndata = res.data
                      var columns = this.drilldowndata.columns
                      //var rowsdata = this.drilldowndata.rowsdata
                      console.log("API Response",this.drilldowndata)
                      var drilldownlevels = [...new Set(columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
                      var levelColumns = []
                      var headerColumns = []
                      for (var i=1; i<=drilldownlevels.length; i++)
                      {
                          var value ='level'+i
                          levelColumns[i] = columns.filter( ind => ind.drilldownLevel ==value)
                          headerColumns[i] = levelColumns[i].map(function (el) { return el.headerColumnDisplay;})
                      }
                      //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
                      console.log("Drilldown data level1",headerColumns[1])
                      console.log("Drilldown data level2",headerColumns[2])
                      console.log("Drilldown data level3",headerColumns[3])

                      }, err => {
                      console.log('Error Fetching data', err)
                      })

                     //Post Request
                     const params = new URLSearchParams();
                     params.append('param1', 'value1');
                     params.append('param2', 'value2');
                     axios.post('/api/testparams', params)
                     //axios.post('/api/reportConfigColumn/'+ menuParam +'/G01')
                     .then(res => {
                      this.string = res.data
                     //var columns = this.drilldowndata.columns
                     //var rowsdata = this.drilldowndata.rowsdata
                     console.log("Post API Called",this.string)
                     }, err => {
                         console.log('Error Fetching data', err)
                         })
                 }*/
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      console.log("menuDetails",menuDetails);
      await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success")
    }
  }
}
</script>
<style >
.card-body{
  padding: 1px;
}

th {
  font-size: 12px;
}

.grid-container {
  overflow-y: auto;
  height: 500px;
}

a {
  text-decoration: none;
  display: inline-block;
  padding: 8px 16px;
}

a:hover {
  background-color: #ddd;
  color: black;
}

.previous {
  background-color: #f1f1f1;
  color: black;
}

.next {
  background-color: #f1f1f1;
  color: black;
}

.round {
  border-radius: 50%;
}

td {
  text-align: center;
}

td:first-of-type {
  text-align: left;
}
.right {
  display: flex;
  justify-content: right;
}
.left {
  display: flex;
  justify-content: left;
}
.scrollmenuRepo {
  overflow: auto;
  white-space: nowrap;
  height: 500px;
}

.banner-true{
  height: 86vh;
}

.banner-false{
  height: 93vh;
}
</style>